export enum TemplateTypes {
  NOTIFICATION = 1,
  DOCUMENT = 2
}
